import { lazy } from 'react';
import FactoryVendorList from './FactoryVendor';
import FactoryVendorForm from './FactoryVendorForm';

const FactoryVendorConfig = {
    settings: {
        layout: {
            config: {},
        },
    },
    routes: [
        {
            path: '/factoryVendors',
            element: <FactoryVendorList />,
        },
        {
            path: '/addVendor',
            element: <FactoryVendorForm />,
        },
        {
            path: '/editFactoryVendor/:id',
            element: <FactoryVendorForm />,
        },
    ],
};

export default FactoryVendorConfig;
